// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mmWW_IhcJms3il {
  width: 200px;
}
.NOT39CPZ8btUbV {
  display: flex;
  flex-direction: column;
  max-height: 35vh;
  box-shadow: var(--ds-shadow-overlay, 0 4px 8px -2px rgba(9, 30, 66, 0.25), 0 0 0 1px rgba(9, 30, 66, 0.08));
}
.NOT39CPZ8btUbV.ArfqlBJkZK0bQS {
  box-sizing: border-box;
  width: 304px;
  padding: 4px 12px 12px 12px;
  border-radius: 8px;
}
.BMKxMH29R1h5nZ {
  text-align: center;
}
.BMKxMH29R1h5nZ h2 {
  margin-top: 0;
  padding: 0 32px 0 32px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 14px;
  font-weight: var(--ds-font-weight-semibold, 600);
  letter-spacing: -0.003em;
  line-height: 40px;
}
.zKnirEogt4qObj {
  margin-bottom: 8px;
  list-style-type: none;
}
.zKnirEogt4qObj::before {
  content: ' ';
  display: block;
  width: calc(100% - 20px);
  height: 1px;
  margin: 0 auto 8px;
  background-color: var(--ds-border, #091e4224);
}
.bFArgTJTv7ztCJ {
  font-weight: var(--ds-font-weight-bold, 700);
  margin-top: 12px;
  margin-bottom: 4px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  display: block;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"select": `mmWW_IhcJms3il`,
	"menu": `NOT39CPZ8btUbV`,
	"emptyState": `ArfqlBJkZK0bQS`,
	"emptyStateHeader": `BMKxMH29R1h5nZ`,
	"menuButton": `zKnirEogt4qObj`,
	"label": `bFArgTJTv7ztCJ`
};
export default ___CSS_LOADER_EXPORT___;
